import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=733d4ce0&scoped=true&"
import script from "./formBox.vue?vue&type=script&lang=js&"
export * from "./formBox.vue?vue&type=script&lang=js&"
import style0 from "./formBox.vue?vue&type=style&index=0&id=733d4ce0&prod&lang=less&scoped=true&"
import style1 from "./formBox.vue?vue&type=style&index=1&id=733d4ce0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733d4ce0",
  null
  
)

export default component.exports